import React from 'react'

import TopicsCard from './TopicsCard'

type ContentHeadProps = {
  author: string
  title: string
  category: string
}

export const ContentHead = ({ author, category, title }: ContentHeadProps) => {
  return (
    <div className="flex flex-col gap-2 items-start">
      <h1 className="text-2xl md:text-3xl font-semibold">{title}</h1>
      {category && <TopicsCard topics={category} />}
      {author && <p className="text-primary-DEFAULT">{author}</p>}
    </div>
  )
}
